import type { NavigateFunction } from 'react-router-dom';

let navigator: NavigateFunction | null = null;

export const setNavigator = (navFn: NavigateFunction) => {
  navigator = navFn;
};

export const navigate = (to: string, options?: { replace?: boolean }) => {
  if (!navigator) {
    throw new Error('Navigator has not been set yet');
  }
  navigator(to, options);
};
